// src/services/api.ts

import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";

// Axios instance létrehozása
// api.ts
console.log(
  "[api.ts] Initial REACT_APP_API_URL:",
  process.env.REACT_APP_API_URL
);

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001",
  headers: {
    "Content-Type": "application/json",
  },
});

// Kérés interceptor (a logolásodat meghagytam, hasznos)
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = localStorage.getItem("auth_token");
    // Logoljuk a teljes URL-t, amihez a kérés megy
    const requestUrl = `${config.baseURL}${config.url}`;
    console.log(
      `[API Interceptor] Executing request to: ${requestUrl}. Token from localStorage:`,
      token
    );

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log(
        "[API Interceptor] Authorization header SET in config:",
        config.headers.Authorization
      );
    } else if (config.headers) {
      delete config.headers.Authorization;
      console.warn(
        "[API Interceptor] Token NOT found or headers missing. Auth header ensured to be NOT SET or REMOVED from config."
      );
    }
    return config;
  },
  (error) => {
    console.error("[API Interceptor] Request error:", error);
    return Promise.reject(error);
  }
);

// Válasz interceptor a token frissítéshez és hibakezeléshez
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error(
      "[API Interceptor] Response error caught. Status:",
      error.response?.status,
      "Data:",
      error.response?.data
    );
    const originalRequest = error.config as InternalAxiosRequestConfig & {
      _retry?: boolean;
    };

    if (error.response?.status === 401 && !originalRequest._retry) {
      console.warn(
        "[API Interceptor] Unauthorized (401) error on original request. Original request:",
        originalRequest.url
      );
      originalRequest._retry = true; // Jelöljük, hogy ezt már próbáltuk

      // Itt most NEM próbálunk token frissítést, mert nincs implementálva.
      // Egyből kijelentkeztetjük a felhasználót, ha 401-et kapunk.
      console.log("[API Interceptor] Triggering logout due to 401.");
      // Fontos: Közvetlenül ne itt hívj authService.logout()-ot, mert az körkörös függőséget okozhat.
      // Ehelyett egy eseményt kellene küldeni, vagy a hívó komponensnek kell kezelnie.
      // Egyelőre csak töröljük a tokent és átirányítunk.
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      // Biztosítjuk, hogy a default header is törlődjön
      delete api.defaults.headers.common["Authorization"];

      // Csak akkor irányíts át, ha nem a login oldalon vagyunk már, hogy elkerüljük a végtelen ciklust
      if (window.location.pathname !== "/login") {
        console.log("[API Interceptor] Redirecting to /login due to 401.");
        window.location.href = "/login"; // Erőltetett átirányítás
      }
      return Promise.reject(error); // Elutasítjuk az eredeti hibát
    }
    return Promise.reject(error);
  }
);

// API végpontok típusai
export interface AuthEndpoints {
  login: (credentials: {
    email: string;
    password: string;
  }) => Promise<AxiosResponse>;
  registerCustomer: (data: any) => Promise<AxiosResponse>;
  registerShop: (data: any) => Promise<AxiosResponse>;
  logout: () => Promise<AxiosResponse>;
}

// API végpontok implementációja
export const authApi: AuthEndpoints = {
  login: (credentials) => api.post("/auth/login", credentials),
  registerCustomer: (data) => api.post("/auth/register/customer", data),
  registerShop: (data) => api.post("/auth/register/shop", data),
  logout: () => api.post("/auth/logout"),
};

export default api;
